export class Setting {
	public id: string;
	public value: string;
}

export const SETTINGS: Setting[] = [
	{
		id: 'api_service_domain',
		value: '/api'
	}
];


// WEBPACK FOOTER //
// ./src/common/modules/core/models/Setting.ts